import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Button = styled(ButtonBase)`
    margin-top: 30px;
    width: 100%;

    button {
        width: 100%;

        & > span:first-child {
            ${(props) => props.theme.typo.bodyM};
            ${(props) => props.theme.fontWeight.medium};
            text-decoration: none;
        }
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 0px;
    }
`

export const Wrapper = styled.div`
    padding: 50px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        padding: 100px 0;
    }
`

export const List = styled.div`
    max-width: 800px;
    width: 100%;
`

export const Title = styled.h2`
    ${(props) => props.theme.typo.displayM}
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.fontWeight.bold};
    margin-bottom: 50px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayL}
        margin-bottom: 50px;
    }
`

export const SideWrapper = styled.div`
    width: 100%;

    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 270px;
        margin-left: 30px;
    }
`

export const Link = styled(LinkBase)`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;

    &:hover {
        color: ${(props) => props.theme.color.g500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.g500};
            }
        }
    }
`

export const BannerWrapper = styled.div`
    width: 100%;
    border-radius: 7px;
    position: relative;
    overflow: hidden;
    margin-top: 50px;
`

export const BannerImage = styled(ImageBase)`
    width: 100%;
`

export const BannerContent = styled.div`
    ${(props) => props.theme.typo.bodyM}
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: end;
`

export const BannerTitle = styled.div`
    color: ${(props) => props.theme.color.g100};
    ${(props) => props.theme.fontWeight.medium}
`

export const BannerDescription = styled.div`
    margin-top: 10px;
    color: ${(props) => props.theme.color.g100};
    margin-bottom: 10px;
`
